var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1749 633L1749 661",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1749.5,
    cy: 628.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.99 628.19C1744.99 624.283 1748.29 621.117 1752.36 621.117C1752.94 621.117 1753.51 621.184 1754.06 621.308C1752.74 620.48 1751.19 620 1749.52 620C1744.81 620 1741 623.806 1741 628.5C1741 633.194 1744.81 637 1749.52 637C1751.81 637 1753.89 636.093 1755.43 634.62C1754.49 635.032 1753.45 635.263 1752.36 635.263C1748.29 635.263 1744.99 632.096 1744.99 628.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1758.4 627.6L1758.37 625.146L1756.54 626.719L1754.3 626.056L1755.11 628.337L1753.77 630.381L1756.1 630.218L1757.5 632.144L1758.13 629.763L1760.34 628.909L1758.4 627.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.09d9b257d4b2e79032b2389a2dc83761.svg";
export { ForwardRef as ReactComponent };